package org.multiplatform.kotfolio.pages.compose

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul

@Page("/compose/preview")
@Composable
fun PreviewComposePage() {
    BlogLayout(
        PageProperties(
            "Preview",
            ""
        ),
        BlogProperties("Jetpack Compose", "Preview")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "@PreviewParameter",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    @Preview(showBackground = true)
                    @Composable
                    fun GreetingPreview() {
                        Text(text = "Hello, Jetpack Compose!")
                    }
                    """.trimIndent()
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "One of the standout features of Jetpack Compose is @Preview annotation, which lets you preview your composable functions in Android Studio’s Design Preview pane. Instead of running your app on a device or emulator, you can instantly see how your UI components will look like and making it easier to refine your designs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "PreviewParameterProvider",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Define a class that implements PreviewParameterProvider and provides a sequence of HomeViewState objects for different scenarios:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    class HomeViewStateProvider : PreviewParameterProvider<HomeViewState> {
                        val homeViewState = HomeViewState(
                            title = "",
                            subTitle = "",
                            hasError = false,
                            isLoading = false,
                            items = emptyList()
                        )

                        override val values: Sequence<HomeViewState> = sequenceOf(
                            // Empty list state
                            homeViewState.copy(title = "Some title", subTitle = "Some subtitle", items = emptyList()),
                            // State with items
                            homeViewState.copy(
                                title = "Some title",
                                subTitle = "Some subtitle",
                                items = listOf("itemOne", "itemTwo")
                            ),
                            // Error state
                            homeViewState.copy(
                                title = "Some title",
                                subTitle = "Some subtitle",
                                hasError = true,
                                items = listOf("itemOne", "itemTwo")
                            ),
                            // Loading state
                            homeViewState.copy(
                                title = "Some title",
                                subTitle = "Some subtitle",
                                isLoading = true,
                                items = listOf("itemOne", "itemTwo")
                            )
                        )
                    }
                    
                    @Preview(showBackground = true)
                    @Composable
                    fun HomeScreenPreview(@PreviewParameter(HomeViewStateProvider::class) viewState: HomeViewState) {
                        HomeScreen(viewState = viewState)
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Preview
                    @Composable
                    fun TextPageNoButtonsPreview {
                            TextPage (text = LoremIpsum (words: 100).values.first()
                        )
                    }
                    
                    @Preview
                    @Composable
                    fun TextPageBothButtonsPreview(
                        @PreviewParameter(LoremIpsum:: class) text: String
                    )
                    {
                        TextPage(
                            text = text,
                            onNextPage = {},
                            onPreviousPage = {}
                        )
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Dart Mode Preview
                    
                    @Preview(name = "Night mode", uiMode = UI_MODE_NIGHT_YES, showBackground = true)
                    @Composable
                    fun StarWarsMovieDarkModePreview() {
                        AdvancedComposePreviewsTheme {
                            Box(modifier = Modifier.padding(8.dp)) {
                                StarWarsMovieCard(movie = movies[2])
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Font
                    @Preview(name = "Large font", fontScale = 1.5f) 
                    
                    //Multiple Devices
                    @Preview(device = Devices.PIXEL_4)
                    @Preview(device = Devices.NEXUS_7)
                    
                    //Custom Background Color
                    @Preview(backgroundColor = 0xFFFF0000, showBackground = true)
                    
                    //SystemUI Elements
                    @Preview(showSystemUi = true)
                    """.trimIndent()
            )
        }
    }
}